import { ENV } from '@wolffun/env-var';
import { getAppConfig } from '@wolffun/app-config';
const {
  chain: {
    chainProvider,
    thetanChainId
  }
} = getAppConfig();
export const THETA_CHAIN_PROVIDER_URL = (() => {
  const apis = {
    production: 'https://bsc-dataseed.binance.org',
    uat: 'https://data-seed-prebsc-2-s1.binance.org:8545',
    staging: 'https://data-seed-prebsc-2-s1.binance.org:8545',
    test: 'https://data-seed-prebsc-2-s1.binance.org:8545'
  };
  return chainProvider || apis[ENV];
})();
export const THETA_CHAIN_ID = (() => {
  const apis = {
    production: '0x38',
    uat: '0x61',
    staging: '0x61',
    test: '0x61'
  };
  return thetanChainId || apis[ENV];
})();
export const THETA_CHAIN_ID_NUMBER = (() => {
  const apis = {
    production: 56,
    uat: 97,
    staging: 97,
    test: 97
  };
  return apis[ENV];
})();
export const POLYGON_CHAIN_ID_NUMBER = (() => {
  const apis = {
    production: 137,
    uat: 80001,
    staging: 80001,
    test: 80001
  };
  return apis[ENV];
})();